import { socialLinks } from './siteData';


export const socialApps = socialLinks.map((link) => ({
  ...link,
  image: null,
  icon: link.label.slice(0, 2).toUpperCase(),
  category: link.type,
}));

// This is a public portfolio viewer configuration. The demo PIN protects
// nothing real and no private keys, seed phrases, credentials, or signing
// capability should ever be added here.
export const publicWallet = {
  demoPin: '1111',
  assets: [
    { symbol: 'BTC', name: 'Bitcoin', network: 'Bitcoin', balance: null, valueUsd: null, allocation: null, publicAddress: null },
    { symbol: 'ETH', name: 'Ethereum', network: 'Ethereum', balance: null, valueUsd: null, allocation: null, publicAddress: null },
  ],
  collectibles: [],
  publicAddresses: [
    { symbol: 'ETH', address: '0x3a186E6B3d16c120c64f04571fab9F2F8B92cE11' },
    { symbol: 'BTC', address: 'bc1q0gnxahza0q80zqjjmggazw53hygd9cuf8vugsx' },
  ],
  activity: [],
};
